import React from 'react';
import { FooterBookingStyled } from './footer-booking.styled';
import Button from '../../../../base/button/button';
import { FooterBookingVariant } from './constants';
import { ButtonVariant } from '../../../../base/button/constants';
import { MakeReservationVariant } from '../../make-reservation.constants';

interface FooterCalendarProps {
  events: any;
  showEvents?: boolean;
  secondButton: {
    buttonText: string;
    onClickButton: () => void;
  };
}

export interface FooterBookingProps {
  variant?: FooterBookingVariant;
  footerCalendarProps?: FooterCalendarProps;
  disabled?: boolean;
  buttonText: string;
  onClickButton: () => void;
  calendarVariant?: MakeReservationVariant;
}

const FooterBooking = (props: FooterBookingProps) => {
  const {
    variant = FooterBookingVariant.Default,
    footerCalendarProps,
    calendarVariant,
  } = props;

  if (variant === FooterBookingVariant.Default && footerCalendarProps) {
    throw new Error(
      'Cannot declare footerCalendarProps in footer variant default',
    );
  }

  return (
    <FooterBookingStyled.Container container item xs={12} md={10}>
      <FooterBookingStyled.ContainerDescription item xs={12} md={9}>
        {variant === FooterBookingVariant.FooterCalendar &&
          footerCalendarProps?.showEvents && footerCalendarProps.events.length > 0 && (
            <FooterBookingStyled.Description>
              {`${footerCalendarProps.events.length} eventi`}
            </FooterBookingStyled.Description>
          )}
        {calendarVariant === MakeReservationVariant.AdminHandleReservation &&
          footerCalendarProps && (
            <FooterBookingStyled.ContainerButton item xs={12} md={4}>
              <Button
                onClick={footerCalendarProps?.secondButton.onClickButton}
                label={footerCalendarProps?.secondButton?.buttonText}
                variant={ButtonVariant.Outlined}
              />{' '}
            </FooterBookingStyled.ContainerButton>
          )}
      </FooterBookingStyled.ContainerDescription>
      <FooterBookingStyled.ContainerButton item xs={12} md={3}>
        <Button
          disabled={props.disabled}
          onClick={props.onClickButton}
          label={props.buttonText}
        />
      </FooterBookingStyled.ContainerButton>
    </FooterBookingStyled.Container>
  );
};

export default FooterBooking;
